import { DecimalPipe } from '@angular/common';
import { CompoundTranslationType, PolygonType } from '../contracts';

export class BaseComponent {
    constructor(protected locale) {

    }

    public getPolygonTypeString(type: PolygonType): string {
        if (type === PolygonType.V1) {
            return 'V1';
        }
        return 'V2';
    }

    public getTranslationTypeString(type: CompoundTranslationType): string {
        if (type === CompoundTranslationType.Activity) {
            return 'Aktiviteter';
        }
        if (type === CompoundTranslationType.PollutionCause) {
            return 'Brancher';
        }
        return 'Stoffer';
    }

    public getValidNumber(val: number): number {
        const result = (!val || isNaN(val) || !Number.isFinite(val)) ? 0 : val;
        return result;
    }

    public getFactor(factor, gvk, conc): string {
        if (gvk === 0 && conc === 0) { // Only if we have no factor and no conc.
            return '-';
        }
        if (conc === 0) {
            return '0';
        } else {
            return this.getNumberWithSignificantDigits(factor);
        }
    }

    public getQualityCriterium(gvk): string {
        if (gvk > 0) {
            return this.getNumberWithSignificantDigits(gvk);
        } else { // Assume gvk 0 = no criterium
            return '-';
        }
    }

    public getNumberWithSignificantDigits(val: number): string {
        const n = this.getValidNumber(val);
        let digitsInfo = '';
        if (n >= 10.0) { // xx.x
            digitsInfo = '1.1-1';
        } else if (n >= 1.0) { // x.xx
            digitsInfo = '1.2-2';
        } else if (n >= 0.1) {// 0.xxx
            digitsInfo = '1.3-3';
        } else if (n >= 0.01) { // 0.0xxx
            digitsInfo = '1.4-4';
        } else { // 0.00xxx
            digitsInfo = '1.5-5';
        }

        const result = new DecimalPipe(this.locale).transform(n, digitsInfo);
        return result;
    }
}
